import { Component, Vue, Watch } from 'nuxt-property-decorator';
import { Locale } from 'date-fns';
import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';

interface IFormatOptions {
  delimiter?: string;
  format?: Array<
    'years' | 'months' | 'weeks' | 'days' | 'hours' | 'minutes' | 'seconds'
  >;
  locale?: Locale;
  zero?: boolean;
}

@Component
export default class Countdown extends Vue {
  countdownEndTime = 0;
  countdownInterval: ReturnType<typeof setInterval> | null = null;
  countdownTimeRemaining = '';
  countdownFormatOptions: IFormatOptions | null = null;

  get isCountdownEndTimeInFuture() {
    return Date.now() < this.countdownEndTime;
  }

  @Watch('countdownEndTime', { immediate: true })
  handleCountdownEndTimeChange(
    current: number | undefined,
    previous: number | undefined,
  ) {
    if (current && current !== previous) {
      this.setCountdownTimer();
    }
  }

  setCountdownTimer() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.setCountdownTimeRemaining();
    this.countdownInterval = setInterval(() => {
      if (!this.isCountdownEndTimeInFuture && this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
        return;
      }
      this.setCountdownTimeRemaining();
    }, 1000);
  }

  setCountdownTimeRemaining() {
    if (!this.countdownEndTime) {
      return;
    }
    const duration = intervalToDuration({
      end: this.countdownEndTime,
      start: this.isCountdownEndTimeInFuture
        ? Date.now()
        : this.countdownEndTime,
    });
    this.countdownTimeRemaining = formatDuration(
      duration,
      this.countdownFormatOptions || undefined,
    );
  }
}
